import { useContext } from "react";
import styles from "../DeleteStore/DeleteStoreModal.module.css";
import { deleteTemplateFromDatabase } from '../../../hooks/Template';
import { TemplateContext } from "../../../context/TemplateContext";

function Modal({ closeModal }) {
  const { selectedTemplate, setIsDeletedTemplate } = useContext(TemplateContext);

  const deleteStore = async () => {
    if(selectedTemplate != null) {
        try {
          const response = await deleteTemplateFromDatabase(selectedTemplate.id); 

          if (response) {
            setIsDeletedTemplate(true)
            closeModal()
          } else {
            setIsDeletedTemplate(false)
              console.error("Failed to fetch stores or no stores found.");
          }
      } catch (error) {
        setIsDeletedTemplate(false)
        console.error("Error fetching stores:", error);
      }
    }
  }
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
            <h1>Deseja excluir o template selecionado?</h1>
            <p>{"Id: "+selectedTemplate.id}</p>
            <p>{"Nome do template: "+selectedTemplate.templateName}</p>
        </div>
        <div className={styles.buttonContent}>
          <button className={styles.buttonConfirm} onClick={ deleteStore }>Deletar</button>
          <button onClick={ closeModal } className={styles.buttonCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default Modal;
